import React, { Fragment, useState } from "react";

import { Nav } from "./styles";
import { Container } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import {
  HiOutlineChevronRight,
  HiOutlineChevronDown,
  HiOutlineChevronUp,
} from "react-icons/hi";
import Category from "./Categories";
import Brand from "./Brands";
import { useOpen } from "../../../hooks/Open";
import { useNavigate } from "react-router";
import { useUserData } from "../../../hooks/UserContext";
import Title from "../../../components/Title";
import { trackClick } from "../../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../../utils/marketplaceTagIds";
import { useFeatureFlag } from "../../../contexts/FeatureFlagProvider";

export default function SidebarContainer() {
  const { setCategory, setBrands, brands, category, OpenButton } = useOpen();
  const { isPJ } = useUserData();
  const navigate = useNavigate();
  const [expandedMenu, setExpandedMenu] = useState("Viagens");
  const travelEnabled = useFeatureFlag("travel");
  const hotelsEnabled = useFeatureFlag("hotels");
  const carRentalEnabled = useFeatureFlag("car_rental");
  const favoritesEnabled = useFeatureFlag("favorites");
  const showTravelMenu = travelEnabled || hotelsEnabled || carRentalEnabled;

  const MENU_SCREEN_NAME = "menu";
  const TAG_ID = "02";
  const CONTENT_TYPE = "menu";

  const handleClickCategory = () => {
    trackClick({
      title: "categorias",
      contentType: CONTENT_TYPE,
      screenName: MENU_SCREEN_NAME,
      tagId: tagIdFromLegacySuffix(TAG_ID),
    });
    setCategory(!category);
  };

  const handleClickBrand = () => {
    trackClick({
      title: "marcas",
      contentType: CONTENT_TYPE,
      screenName: MENU_SCREEN_NAME,
      tagId: tagIdFromLegacySuffix(TAG_ID),
    });
    setBrands(!brands);
  };

  const redirectPage = (page) => {
    OpenButton();
    navigate(page);
  };

  const redirectPageAereo = (page) => {
    window.location.href = page;
  };

  const handleMenuClick = (menuName, path) => {
    trackClick({
      title: menuName.toLowerCase(),
      contentType: CONTENT_TYPE,
      screenName: MENU_SCREEN_NAME,
      tagId: tagIdFromLegacySuffix(TAG_ID),
    });
    OpenButton();
    navigate(path);
  };

  const handleSubMenuClick = (subItemLabel, path) => {
    trackClick({
      title: subItemLabel.toLowerCase().replace(/\s/g, "-"),
      contentType: CONTENT_TYPE,
      screenName: MENU_SCREEN_NAME,
      tagId: tagIdFromLegacySuffix(TAG_ID),
    });
    OpenButton();
    navigate(path);
  };

  const { userData } = useUserData();

  const AllMenus = {
    Categorias: "/loja/categories/",
    Marcas: "/loja/brands/",
    Favoritos: "/loja/favorites/",
    "Minha Conta": isPJ ? "/loja/pj/myaccount/" : "/loja/myaccount/",
    "Meus Pedidos": "/loja/myrequests/",
    FAQ: "/loja/policy/",
  };

  const viagensSubItems = [
    hotelsEnabled
      ? { label: "Hotéis", path: "/loja/hoteis/", isNew: true }
      : null,
    travelEnabled
      ? {
          label: "Passagens aéreas",
          path: "/loja/passagens-aereas/",
          isNew: false,
        }
      : null,
    carRentalEnabled
      ? {
          label: "Aluguel de carros",
          path: "/loja/search-cars-result",
          isNew: false,
        }
      : null,
  ].filter(Boolean);

  const MenuWithSubItems = {
    Viagens: {
      subItems: viagensSubItems,
    },
  };

  // Define a ordem dos itens do menu
  const menuOrder = [
    { type: "simple", key: "Categorias" },
    { type: "simple", key: "Marcas" },
    ...(showTravelMenu ? [{ type: "expandable", key: "Viagens" }] : []),
    ...(favoritesEnabled ? [{ type: "simple", key: "Favoritos" }] : []),
    { type: "simple", key: "Minha Conta" },
    { type: "simple", key: "Meus Pedidos" },
    { type: "simple", key: "FAQ" },
  ];

  const handleMenuToggle = (menuName) => {
    const isCurrentlyExpanded = expandedMenu === menuName;
    const newState = isCurrentlyExpanded ? null : menuName;

    if (!isCurrentlyExpanded) {
      trackClick({
        title: `abriu-${menuName.toLowerCase()}`,
        contentType: CONTENT_TYPE,
        screenName: MENU_SCREEN_NAME,
        tagId: tagIdFromLegacySuffix(TAG_ID),
      });
    }

    setExpandedMenu(newState);
  };

  return (
    <>
      <Nav style={{ top: "20px" }}>
        <Container
          className="container-custom"
          sx={{
            borderTop: "1px solid #dee2e6",
            marginTop: "0px !important",
          }}
        >
          <div className="menu-wl menu">
            <Title titleClass="text-center width-100" label="Menu" />
            <ul className="mt-4 padding-left-9">
              {/* Renderiza os itens na ordem definida */}
              {menuOrder.map((item, index) => {
                if (item.type === "simple") {
                  const menu = item.key;
                  return (
                    <Fragment key={`simple-${index}`}>
                      <li className="my-4">
                        <a
                          href={AllMenus[menu]}
                          className="d-flex justify-content-between align-items-center w-100"
                          onClick={(e) => {
                            e.preventDefault();
                            handleMenuClick(menu, AllMenus[menu]);
                          }}
                        >
                          {menu}
                          <HiOutlineChevronRight />
                        </a>
                      </li>
                      <hr />
                    </Fragment>
                  );
                } else if (item.type === "expandable") {
                  const menu = item.key;
                  const menuData = MenuWithSubItems[menu];
                  const isExpanded = expandedMenu === menu;
                  const subItems = menuData?.subItems || [];

                  if (
                    menu === "Viagens" &&
                    (!showTravelMenu || subItems.length === 0)
                  ) {
                    return null;
                  }

                  return (
                    <Fragment key={`expandable-${index}`}>
                      <li
                        className="d-flex justify-content-between align-items-center my-4"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleMenuToggle(menu)}
                      >
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "var(--primary-color)",
                            fontSize: "1rem",
                            marginLeft: 0,
                          }}
                        >
                          {menu}
                        </span>
                        {isExpanded ? (
                          <HiOutlineChevronUp />
                        ) : (
                          <HiOutlineChevronDown />
                        )}
                      </li>
                      {isExpanded && (
                        <ul
                          style={{
                            listStyle: "none",
                            paddingLeft: "1rem",
                            marginTop: "0.5rem",
                            marginBottom: "0.5rem",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {subItems.map((subItem, subIndex) => (
                            <li
                              key={`subitem-${subIndex}`}
                              className="d-flex align-items-center py-2 submenu-item"
                              style={{
                                cursor: "pointer",
                                color: "var(--primary-color)",
                                fontSize: "0.95rem",
                                fontWeight: "normal",
                                opacity: 0.85,
                              }}
                              onClick={() =>
                                handleSubMenuClick(subItem.label, subItem.path)
                              }
                            >
                              {subItem.label}
                              {subItem.isNew && (
                                <span
                                  style={{
                                    width: "40px",
                                    height: "20px",
                                    marginLeft: "8px",
                                    backgroundColor: "#b5922a",
                                    color: "#fff",
                                    fontSize: "0.7rem",
                                    fontWeight: "bold",
                                    padding: "4px",
                                    borderRadius: "2px",
                                    opacity: 1,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                  }}
                                >
                                  Novo
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                      <hr />
                    </Fragment>
                  );
                }
                return null;
              })}
            </ul>
          </div>
        </Container>
        {category && <Category />}
        {brands && <Brand />}
      </Nav>
    </>
  );
}
